// extracted by mini-css-extract-plugin
export default {"buttonlogout":"UserMenu_buttonlogout__fyXyl"};